import Modal from 'apollo-react/components/Modal';
import qs from 'query-string';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getConfirmModalOpen } from './../../../selectors/common.selectors';
import { useFormSelector } from '../../../../custom-hooks';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { saveEditor, setConfirmModalOpen } from '../../../actions/editor.actions';
import { SAVE_ACTION_TYPE } from '../../../constants/editor.constants';
import { getIsImportMode } from '../../../selectors/editor.selectors';

const ConfirmModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const modalOpen = useFormSelector(getConfirmModalOpen);
  const isImportMode = useFormSelector(getIsImportMode);

  const { isCreateForm, formId: linkFormId } = qs.parse(location.search);

  const redirectToAnotherForm = ({ formId, formKey, entityType }) => {
    if (isCreateForm || isImportMode || linkFormId) {
      history.replace(
        `/form-editor?formKey=${formKey}&formId=${formId}&entityType=${entityType}&standaloneLayout=true`
      );
    } else {
      window.location.reload();
    }
  };

  const handleSaveProgressButton = async () => {
    await dispatch(
      saveEditor({
        saveAction: isImportMode
          ? SAVE_ACTION_TYPE.IMPORT
          : isCreateForm && SAVE_ACTION_TYPE.CREATE_FORM,
        redirectToAnotherForm,
      })
    );
    dispatch(setConfirmModalOpen(false));
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => dispatch(setConfirmModalOpen(false))}
      title={translateString('Sub Form added')}
      message={translateString(
        'The Sub Form will be displayed inline when saving your pending changes.'
      )}
      buttonProps={[
        { label: translateString('Close and Save Later'), variant: 'secondary' },
        { label: translateString('Save and Reload'), onClick: handleSaveProgressButton },
      ]}
      disableBackdropClick
      disableEscapeKeyDown
    />
  );
};

export default ConfirmModal;
